<!-- =========================================================================================
  File Name: ListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <location-setting-side-bar :isLocationSidebarActive="addSettingSidebar"
                               @close-sidebar="toggleLocationSettingDataSidebar" :data="locationSettingSideBarData"/>
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata"  @gotoprofile="gotoprofile" @close-sidebar="toggleDataSidebar" :data="sidebarData"/>
    <schedule-view-sidebar :isSidebarActive="addScheduleSidebar" @close-sidebar="toggleScheduleSidebar"
                           :data="scheduleData"/>
    <add-camera-sidebar :isSidebarActive="addNewCameraSidebar" @close-sidebar="toggleCameraSidebar" :data="cameraSidebarData" />
    <data-manager-sidebar :isManagerSidebarActive="addNewManagerSidebar" @getdata="getdata" @closeManagerSidebar="toggleManagerSidebar" :data="ManagerSidebarData" />


    <!-- ADD NEW -->
    <div>
      <vs-button class="user_add_btn" type="filled" @click.native="addNewData">
        <feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3"/>
        New Location
      </vs-button>
      <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
    </div>
    <div class="demo-alignment">
      <!--      <vs-popup  classContent="popup-example" title="Manage Location" :active.sync="popupActive2">-->
      <vs-popup fullscreen title="" :active.sync="popupActive2">
        <div class="p-3">
          <vs-row vs-w="12">
            <vs-col vs-lg="4" vs-sm="3" vs-xs="5">
              <vs-input label="Name" class="w-full" name="item-name" v-validate="'required'"/>
            </vs-col>

            <vs-col vs-lg="7" vs-sm="4" vs-xs="4" v-for="(formData, index) in schedules.data" :key="index">
              <vs-row vs-w="12">
                <vs-col vs-lg="4" vs-sm="5" vs-xs="5">
                  <label>Schedule</label>
                  <v-select :closeOnSelect="false" v-model="selectedd" :options="options"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"/>

                </vs-col>
                <vs-col vs-lg="8" vs-sm="5" vs-xs="5">
                  <label>Time</label>
                  <div class="slot-fields">
                    <flat-pickr v-model="start_time" :config="configdateTimePicker" class="picker" name="start_time"
                                placeholder="Start time"/>

                    <flat-pickr v-model="end_time"  :config="configdateTimePicker" class="picker" name="start_time"
                                placeholder="End Time time"/>
                  </div>
                </vs-col>
              </vs-row>
            </vs-col>

            <vs-col vs-lg="1" vs-sm="1" vs-xs="1">
              <div class="mt-8 float-left">
                <vs-button color="primary" size="small"
                           @click.native="inputRemoveDate(index)">-
                </vs-button>
                <vs-button color="primary" size="small"
                           @click.native="inputAddDate()">+
                </vs-button>

              </div>

            </vs-col>


          </vs-row>
          <br>
          <vs-row vs-w="12">
            <vs-col vs-lg="10" vs-sm="7" vs-xs="7">
              <div class="slot-fields" v-for="(formData, index) in videos.data" :key="index">
                <vs-row vs-w="12">
                  <vs-col vs-lg="2" vs-sm="7" vs-xs="7">
                    <vs-input label="Camera Name" class="mt-5 w-full" name="camera_name" v-validate="'required'"/>

                  </vs-col>
                  <vs-col vs-lg="2" vs-sm="7" vs-xs="7">
                    <!-- CAMERA CODE -->
                    <vs-input label="Camera code" class="mt-5 w-full" name="camera_code" v-validate="'required'"/>
                  </vs-col>
                  <vs-col vs-lg="2" vs-sm="7" vs-xs="7">
                    <!-- CAMERA CODE -->
                    <!-- CAMERA ID -->
                    <vs-input label="Camera ID" class="mt-5 w-full" name="camera_id"/>
                  </vs-col>
                  <vs-col vs-lg="2" vs-sm="7" vs-xs="7">
                    <div class="slot-actions pr-2 mt-1 mt-12 ml-2">
                      <vs-button color="primary" size="small"
                                 @click.native="inputRemove(index)">-
                      </vs-button>
                      <vs-button color="primary" size="small"
                                 @click.native="inputAdd()">+
                      </vs-button>
                      <br>
                    </div>
                  </vs-col>
                </vs-row>
                <!-- NAME -->

                <label>Locations</label>

                <ul class="centerx mt-2  flex flex-wrap">
                  <li class="ml-1" v-for="location in locations" :key="location.id">
                    <vs-radio v-model="dataLocation" :vs-value="location.id">{{ location.name }}</vs-radio>
                  </li>
                </ul>

                <br>
                <label class="mb-4">Select Color</label>
                <ul class="clearfix">
                  <!-- Custom Color Square -->
                  <li class="float-left">
                    <input class="w-10 cursor-pointer h-10 rounded-lg m-2" type="color" name="color_code"/></li>
                </ul>

              </div>
            </vs-col>

          </vs-row>


        </div>

      </vs-popup>
    </div>
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="locations">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="selected.length>0" vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>

            <vs-dropdown-menu>
                   <vs-dropdown-item  @click="genQr()" >
                <span class="flex items-center">
                  <feather-icon icon="CodepenIcon" svgClasses="h-4 w-4" class="mr-2"  />
                  <span>{{ $t('common.qr_code') }}</span>
                </span>
              </vs-dropdown-item>

              <!-- <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item> -->

            </vs-dropdown-menu>
          </vs-dropdown>
            <h6> Showing {{queriedlocations}} Locations </h6>

          <!-- ADD NEW -->
<!--          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">-->
<!--              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />-->
<!--              <span class="ml-2 text-base text-primary">Add New</span>-->
<!--          </div>-->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ locations.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : locations.length }} of {{ queriedlocations }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <!-- <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item> -->
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <!-- <vs-checkbox v-model="headCheckbox" @input="CheckAll()"></vs-checkbox> -->
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="name">Timezone</vs-th>
        <vs-th sort-key="name">Managers</vs-th>
        <vs-th sort-key="name">Cameras</vs-th>
        <vs-th>Action</vs-th>
      </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" v-bind:class="{ 'bg-light_danger': !tr.billing, 'text-dark': !tr.billing }" >
              <!-- <vs-td><vs-checkbox  @input="SelectItem(tr.id)" v-model="selectedCheck[indextr]"></vs-checkbox></vs-td> -->
              <vs-td>
                <router-link :to="{ path: '/locations/'+ tr.id}" class="text-inherit product-name font-medium truncate">{{ tr.name }}</router-link>
              </vs-td>
               <vs-td v-if="tr.timezone">{{tr.timezone.name}} </vs-td>
               <vs-td v-else> </vs-td>

                 <vs-td>
                <div v-for="item in tr.managers" :key="item.id">
                 <vs-chip >{{item.fname}} {{item.lname}}</vs-chip>
                </div>
                    <vs-row>
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
              <vs-button :disabled="!tr.billing"  class="text-center"   @click.native="addNewManager(tr)" size="small" icon-pack="feather" icon="icon-user-plus"></vs-button>
              </vs-col>
               </vs-row>
              </vs-td>
                <vs-td>
                <vx-tooltip class="vs-display" v-for="camera in tr.cameras" :key="camera.id" :text="camera.name" position="top">
                  <p  :style="{background: camera.color_code}" class="w-4 h-4 round" style="float: left">
                  </p>
                </vx-tooltip>

                  <br v-if="tr.cameras.length>0">
                 <!-- <vs-button class="w-2 h-2 round"  @click="addCameraData(tr)"  icon="add">
                  </vs-button> -->
                <vs-row >
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
              <!-- <vs-button  class="text-center" @click.stop="addCameraData(tr)" size="small">Add New Camera
              </vs-button> -->
             <vs-button :disabled="!tr.billing"  icon="add_a_photo" @click.native="addCameraData(tr)" size="small"></vs-button>
              <!-- <vs-button class="text-center" icon-pack="feather" icon="icon-plus"  @click.stop="addCameraData(tr)" size="small"></vs-button> -->
              </vs-col>
               </vs-row>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer" v-if="tr.billing">
                  <div>
                    <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" />
                  </div>
                <vs-dropdown-menu>
                <vs-dropdown-item @click="editData(tr)">
                <span class="flex items-center" >
                <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                <span> Edit </span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item  @click="confirmDeleteRecord(tr)">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>Delete</span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="locationSettingData(tr)">
                <span class="flex items-center" >
                  <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Settings</span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item  @click="genQr(tr.id)" >
                <span class="flex items-center">
                  <feather-icon icon="CodepenIcon" svgClasses="h-4 w-4" class="mr-2"  />
                  <!-- <span>{{ $t('common.qr_code') }}</span> -->
                  <span>Get Registration Form</span>
                </span>
              </vs-dropdown-item>

                </vs-dropdown-menu>
                </vs-dropdown>
                 <vs-tooltip v-else text="This record is disabled because of its locations’ billing problems">
                   <feather-icon icon="InfoIcon" svgClasses="w-6 h-6" class="ml-2"  />
                 </vs-tooltip>
              </vs-td>

            </vs-tr>
          </tbody>
        </template>

    </vs-table>
    <vs-popup class="holamundo" title=" " :active.sync="QRpopupActive">
             <vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <vue-qrcode :value="Qr_link" :width="300" ref="QR" />
              </vs-col>
               <vs-col  vs-offset="2" vs-w="6" > 
                  <vs-input v-model="Qr_link" class="w-full" disabled></vs-input>
              </vs-col>
              <vs-col vs-w="4"> 
                   <vs-button size="small" class="mt-2 ml-1" 
                                v-clipboard:copy="Qr_link"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError">Copy</vs-button>
              </vs-col>
              <vs-col  vs-offset="2" vs-w="6" > 
                  <vs-input v-model="qr_code" class="w-full" disabled></vs-input>
                  <!-- <vs-button size="small"><small @click="ResetSignup">Reset code</small></vs-button> -->
                                         

              </vs-col>
              <vs-col vs-w="4" class="mb-base"> 
                   <vs-button size="small" class="mt-2 ml-1" 
                                v-clipboard:copy="qr_code"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError">Copy</vs-button>
              </vs-col>
               </vs-row>
              <vs-row >
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <!-- <vs-button class="ml-10">Print</vs-button> -->
              <vs-button  @click.native="genQr(dataId)">Reset code</vs-button>
              <vs-button class="ml-10" @click.native="downloadQR()">Download</vs-button>

              </vs-col>
               </vs-row>
  </vs-popup>
  </div>

</template>

<script>
import {ALL_LOCATIONS, REMOVE_LOCATION, GENERATE_LOCATION_QR} from '@/graphql'
import DataViewSidebar from './addSidebarView.vue'
import LocationSettingSideBar from './locationSettingSidebar.vue'
import ScheduleViewSidebar from './ScheduleViewSidebar'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import AddCameraSiderbar from './addCameraSidebar'
import vSelect from 'vue-select'
import VueQrcode from 'vue-qrcode'
import InviteManagerSidebar from './InviteManagerSidebar'

export default {
  components: {
    DataViewSidebar,
    LocationSettingSideBar,
    ScheduleViewSidebar,
    'v-select': vSelect,
    'add-camera-sidebar': AddCameraSiderbar,
    'DataManagerSidebar': InviteManagerSidebar,
    flatPickr,
    VueQrcode

  },
  data () {
    return {
      locations:'',
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      addNewCamUserSidebar: false,
      addNewCameraSidebar:false,
      addSettingSidebar: false,
      addNewManagerSidebar: false,
      ManagerSidebarData : {},
      locationSettingSideBarData: {},
      sidebarData: {},
      cameraSidebarData: {},
      camUserSidebarData: {},
      scheduleData: {},
      addScheduleSidebar: false,
      DeletedItem: '',
      popupActive2: false,
      dataLocation: [],
      start_time: '',
      end_time: '',

      selectedd: ['Monday'],
      options: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thurdsday', 'Friday', 'Saturday'],
      videos:
        {
          data: [
            {
              'incident_id': '',
              'camera': '',
              'video': '',
              'date': '',
              'start_time': '',
              'end_time': ''
            }
          ]
        },
      schedules:
        {
          data: [
            {
              'incident_id': '',
              'camera': '',
              'video': '',
              'date': '',
              'start_time': '',
              'end_time': ''
            }
          ]
        },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: 'H:i',
        time_24hr: false,
        altInput: true,
        dateFormat: 'H:i'
      },
      headCheckbox:'',
      selectedCheck:[],
      QRpopupActive: false,
      qr_link:'google.com',
      qr_code:null,
      dataId:null


    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products () {
      return this.$store.state.dataList.products
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    },
    // locations () {
    //   return this.$store.state.dataList.locations
    // },
    queriedlocations () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.locations.length
    },
    Qr_link () {
      return this.qr_link
    }

  },
  methods: {
      ResetSignup () {
      // this.dataSignupCode = "L"+Math.random().toString().slice(2, 10)
      // this.$apollo
      //   .mutate({
      //     mutation: UPDATE_LOCATION_SIGNUP_CODE,
      //     variables: {
      //       id :this.dataId,
      //       code: this.dataSignupCode
      //     }
      //   })
      //   .then(response => {
      //     if (response.data.updateLocationSignupCode.status === 'Success') {
      //     }
      //   }).catch(error => {
      //     console.log(error)
      //   })

    },
        onCopy () {
      this.$vs.notify({
        title: 'Success',
        text: 'Text copied successfully',
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon:'icon-check-circle'
      })
    },
    onError () {
      this.$vs.notify({
        title: 'Failed',
        text: 'Error in copying text',
        color: 'danger',
        iconPack: 'feather',
        position: 'top-center',
        icon:'icon-alert-circle'
      })
    },
    gotoprofile (value) {
      this.$router.push({ path: `/locations/${value}` })
    },
    getdata (value) {
      if (value) {
        this.get()
      }
    },
    addCameraData (data) {
      this.cameraSidebarData = data
      this.toggleCameraSidebar(true)

    },
    toggleCameraSidebar (val = false) {
      this.addNewCameraSidebar = val
      if (!val) {
        this.get()
      }
    },
    addNewManager (data) {
      this.ManagerSidebarData = data
      this.toggleManagerSidebar(true)
    },
    toggleManagerSidebar (val = false) {
      this.addNewManagerSidebar = val
    },
    inputRemove (index) {

      this.videos.data.splice(index, 1)
    },
    inputRemoveDate (index) {

      this.schedules.data.splice(index, 1)
    },
    inputAdd () {

      this.videos.data.push({
        'incident_id': '',
        'camera': '',
        'video': '',
        'date': '',
        'start_time': '',
        'end_time': ''

      })
      // console.log(this.videos.data)

    },
    inputAddDate () {

      this.schedules.data.push({
        'incident_id': '',
        'camera': '',
        'video': '',
        'date': '',
        'start_time': '',
        'end_time': ''

      })
      // console.log(this.videos.data)

    },
    StatusSuccess (status, color) {
      this.$vs.notify({
        title: 'Location',
        text: status,
        color,
        position: 'top-right'
      })

    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)

    },
    addNewCamUser (data) {
      this.camUserSidebarData = data
      this.toggleCamUserSidebar(true)
    },
    addSchedule (data) {
      this.scheduleData = data
      this.toggleScheduleSidebar(true)
    },
    confirmDeleteRecord (location) {
      this.DeletedItem = location
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${location.name}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData () {
      this.$apollo
        .mutate({
          mutation: REMOVE_LOCATION,
          variables: {
            id: this.DeletedItem.id,
            schedule_id:this.DeletedItem.schedule.id
          }
        })
        .then(response => {
          this.get()
          if (response.data.deleteLocation.status == 'Success') {
            this.StatusSuccess(response.data.deleteLocation.message, response.data.deleteLocation.color)
            this.$router.push('/locations')
          } else {
            this.StatusSuccess(response.data.deleteLocation.message, response.data.deleteLocation.color)
          }
        }).catch(error => {
          console.log(error)
        })
      // this.$store.dispatch('dataList/removeLocation', id).catch(err => { console.error(err) })
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleLocationSettingDataSidebar (val = false) {
      this.addSettingSidebar = val
      if (!val) {
        this.get()
      }
    },
    locationSettingData (data) {
      this.locationSettingSideBarData = data
      this.toggleLocationSettingDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      if (!val) {
        this.get()
      }
    },
    toggleCamUserSidebar (val = false) {
      this.addNewCamUserSidebar = val
      if (!val) {
        this.get()
      }
    },
    toggleScheduleSidebar (val = false) {
      this.addScheduleSidebar = val
      if (!val) {
        this.get()
      }
    },
    CheckAll () {
      const selected = []
      if (this.headCheckbox) {
        for (let index = 0; index < this.locations.length; index++) {
          this.selectedCheck[index] = true
          selected.push(this.locations[index].id)
        }
        this.selected = selected
      } else {
        for (let index = 0; index < this.locations.length; index++) {
          this.selectedCheck[index] = false
        }
        this.selected = []
      }
    },
    SelectItem (id) {
      if (!this.headCheckbox) {
        let status = false
        for (let i = 0; i < this.selected.length; i++) {
          if (this.selected[i] == id) {
            status = true
          }
        }
        if (status) {
          for (let i = 0; i < this.selected.length; i++) { 
            if (this.selected[i] === id) { 
              this.selected.splice(i, 1) 
            }
          }
        } else {
          this.selected.push(id)
        }
      } else {
        const index = this.selected.indexOf(id)
        if (index > -1) {
          this.selected.splice(index, 1)
        } else {
          this.selected.push(id)
        }
      }
    },
    downloadQR () {
      const img = this.$refs.QR.$el
      const a = document.createElement('a')
      a.href = img.src
      a.download = 'QR_CODE'
      a.click()
      this.QRpopupActive = false
    },
    genQr (id) {
      this.dataId=id
      var qr_code_number = "L"+Math.random().toString().slice(2, 10)
      const path = '/register/'
      const list = []
      list.push(id)
      this.qr_link = process.env.VUE_APP_APP_LINK + path
      this.$apollo
        .mutate({
          mutation: GENERATE_LOCATION_QR,
          variables: {
            code:qr_code_number,
            link:this.qr_link,
            location_id:list
          }
        })
        .then(response => {
          if (response) {
            this.qr_link = this.qr_link+response.data.generateLocationQr.color
            this.qr_code = response.data.generateLocationQr.color
            this.QRpopupActive = true
            this.selected = []
            this.headCheckbox = false
            for (let index = 0; index < this.selectedCheck.length; index++) {
              this.selectedCheck[index] = false
            }
          }
        }).catch(error => {
          console.log(error)
        })
    },
    get () {
      this.$apollo
        .mutate({
          mutation: ALL_LOCATIONS
        })
        .then(response => {
          this.locations = response.data.locations

        })
    }

  },
  created () {
    this.get()

  },
  mounted () {
    this.isMounted = true
  }
}
</script>
<style lang="scss">
//.con-vs-popup .vs-popup{
//  width:50% !important;
//}
#data-list-list-view {
  .user_add_btn {
    float: right;
    margin-top: -50px
  }
  .vs-display {
    display: inline-block
  }

  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }

  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

